import { z } from "@hono/zod-openapi";

export const PROTOCOL_VERSION = 1 as const;
export const MIN_PROTOCOL_VERSION = 1 as const;
export const DEFAULT_CHANGE_PAGE_SIZE = 200 as const;
export const MAX_CHANGE_PAGE_SIZE = 500 as const;
export const MAX_SNAPSHOT_ENTRIES = 25_000 as const;

export const protocolCapabilitiesSchema = z
  .object({
    protocol_version: z.literal(PROTOCOL_VERSION),
    minimum_protocol_version: z.literal(MIN_PROTOCOL_VERSION),
    markdown_body_limit_bytes: z.literal(1_900_000),
    default_change_page_size: z.literal(DEFAULT_CHANGE_PAGE_SIZE),
    maximum_change_page_size: z.literal(MAX_CHANGE_PAGE_SIZE),
    maximum_snapshot_entries: z.literal(MAX_SNAPSHOT_ENTRIES),
    server_id_format: z.literal("uuidv7"),
    operation_id_format: z.literal("uuidv4"),
    content_hash: z.literal("sha256-lowercase-hex"),
    namespace_normalization: z.literal("unicode-nfc-full-case-fold"),
  })
  .openapi("ProtocolCapabilities");

export type ProtocolCapabilities = z.infer<typeof protocolCapabilitiesSchema>;

export const protocolCapabilities: ProtocolCapabilities = {
  protocol_version: PROTOCOL_VERSION,
  minimum_protocol_version: MIN_PROTOCOL_VERSION,
  markdown_body_limit_bytes: 1_900_000,
  default_change_page_size: DEFAULT_CHANGE_PAGE_SIZE,
  maximum_change_page_size: MAX_CHANGE_PAGE_SIZE,
  maximum_snapshot_entries: MAX_SNAPSHOT_ENTRIES,
  server_id_format: "uuidv7",
  operation_id_format: "uuidv4",
  content_hash: "sha256-lowercase-hex",
  namespace_normalization: "unicode-nfc-full-case-fold",
};
